export const modifyPlacement = (coordinate, pageDimensions) => {
  try {
    let [x1, y1, x2, y2] = coordinate.split(",").map(Number)
    let modified = { x1, y1, x2, y2 }
    let uniqueDimensions = [...new Set(pageDimensions)]

    const { width, height } = findSmallestPage(uniqueDimensions)

    const placementWidth = x2 - x1
    const placementHeight = y2 - y1

    if (y1 > height || y2 > height) {
      modified.y1 = height - placementHeight
      modified.y2 = placementHeight + modified.y1
    }
    if (x1 > width || x2 > width) {
      modified.x1 = width - placementWidth
      modified.x2 = placementWidth + modified.x1
    }

    return modified
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const checkOutOfBoundary = (pageDimensions, pageSelection, coordinate) => {
  try {
    let isPlacementGoesOut = false

    // Parse the coordinates for the signature
    let [x1, y1, x2, y2] = coordinate.split(",").map(Number)

    for (let i = 0; i < pageDimensions.length; i++) {
      const pageNumber = i + 1

      if ((pageSelection === "ODD" && pageNumber % 2 === 0) || (pageSelection === "EVEN" && pageNumber % 2 !== 0)) continue

      const [width, height] = pageDimensions[i].split("*").map(Number)

      if (x1 < 0 || y1 < 0 || x2 > width || y2 > height) {
        isPlacementGoesOut = true
        break
      }
    }

    return isPlacementGoesOut
  } catch (error) {
    console.error(error)
    throw error
  }
}

const findSmallestPage = (sizes) => {
  let leastWidth = null
  let leastHeight = null

  for (const size of sizes) {
    const [width, height] = size.split("*").map(Number)

    if (!leastWidth || width < leastWidth) leastWidth = width
    if (!leastHeight || height < leastHeight) leastHeight = height
  }

  return { width: leastWidth, height: leastHeight }
}
